module.exports = __webpack_public_path__ + "img/012.363cda8c.jpg";